// import { configureStore } from '@reduxjs/toolkit'
// import commonReducer from '../features/common/commonSlice'
// export const store = configureStore({
//   reducer: commonReducer
// })
import { persistReducer, persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import commonReducer from '../features/common/commonSlice'
import storage from 'redux-persist/lib/storage'

const persistConfig = {
  key: 'root',
  storage
}

/* 

if reducers are multiple

const rootReducer = combineReducers({ 
  user: userReducer,
  notes: NotesReducer
})

const persistedReducer = persistReducer(persistConfig, rootReducer) */

const persistedReducer = persistReducer(persistConfig, commonReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware({
    serializableCheck: {
      // Ignore redux-persist action types that carry functions
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      // If you ever need to ignore specific paths in actions:
      // ignoredActionPaths: ["meta.arg", "payload.timestamp"],
    },
  }),
})

export const persistor = persistStore(store)
